import React, { Component } from 'react';
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import { Modal } from "reactstrap";
import SubTitle from 'components/FacilityRequestComponents/ResourceComponents/SubTitle';
import EstimatedCostDetailsModal from 'components/FacilityRequestComponents/AH/EstimatedCostDetailsModal';
import styles from '../Maintenance/maintenance.module.css';
import AHstyles from './Modules/AfterHours.module.css';
import PencilIcon from 'Assets/icons/pen.svg';
import DeleteIcon from 'Assets/images/Icons__trash2.svg';
import { GetCalculateCost } from 'action/tenantAction';
import { GetSelectedRequest, DeleteTenantRequests } from 'action/requestAction';
import { setAmplitudeEvent} from 'amplitude/amplitude';


class ViewAfterHoursRequest extends Component {

    componentWillMount() {
        let requestID = this.props.location.pathname.split('=')[1];
        (requestID !== undefined) ? this.props.GetSelectedRequest(requestID) : console.log("redirect back");
    }

    constructor(props) {
        super(props);
        this.state = {
            navigateToEditRequest: false,
            redirectToRequestsList: false,
            modal: false,
            spaceName: "-",
            fromDate: "-",
            toDate: "-",
            requestType: "-",
            comment: "-",
            estimatedValue: '---',
            requestedBy: "-",
            requestStatus: "-",
            editID:null,
            zoneId:null,
            hideEditforRedundantRequest :false
        };
        this.toggle = this.toggle.bind(this);
        this.getEstimatedCost = this.getEstimatedCost.bind(this);
        this.customiseData = this.customiseData.bind(this);
        this.convertUTCString = this.convertUTCString.bind(this);
        this.verifyRequestStatusType = this.verifyRequestStatusType.bind(this);
        this.DeleteRequest = this.DeleteRequest.bind(this);
        this.EditRequest = this.EditRequest.bind(this);
    }

    // componentDidMount() {
    //     let recordDetailID = null;
    //     recordDetailID =  localStorage.getItem("recordID");
    //     console.log(recordDetailID);
    //    if(recordDetailID !== 'null' && recordDetailID !== null && recordDetailID !== undefined){
    //       this.props.GetSelectedRequest(recordDetailID);
    //    }
    //    else{
    //     console.log("workimng baby recordDetailID");
    //     this.setState({ redirectToRequestsList: true });
    //    }
    // }

    componentWillReceiveProps(nextProps) {
        if (this.props.requestdetailsfromReducer !== nextProps.requestdetailsfromReducer) {
            this.customiseData(nextProps.requestdetailsfromReducer);
            this.getEstimatedCost(nextProps.requestdetailsfromReducer);
        }
        if (this.props.Tenant_Request_Cost !== nextProps.Tenant_Request_Cost) {
            let data = null;
            (nextProps.Tenant_Request_Cost.hasOwnProperty('data')) ? data = nextProps.Tenant_Request_Cost.data.cost.currency + nextProps.Tenant_Request_Cost.data.cost.displayTotalAmount : data = "---";
            this.setState({ estimatedValue: data });
        }
    }

    toggle(toggleType) {
        //Open View Details Pop up
        if (toggleType !== "close") {
            setAmplitudeEvent("View After-Hours estimated cost", {
                "Primary Offering": "TS",
                "Current Page": "View After-Hours page"
            });
        }
        if (this.state.estimatedValue !== '---') { this.setState({ modal: !this.state.modal }) }
    }

    render() {
        let {editID,hideEditforRedundantRequest} = this.state;

        if (this.state.redirectToRequestsList) { return <Redirect to={{ pathname: '/FacilityManagement/AfterHours', state: {zoneSelectedfromDropdown: this.state.zoneId} }} /> }          //After Delete, redirecting back to list page.
        if (this.state.navigateToEditRequest && editID !==  null) { return <Redirect to={{ pathname: '/FacilityManagement/EditAfterHoursRequest/EAHR=' + editID }} /> }        //redirecting back to edit page.

        return (
            <div>
                <div className={styles.titleSection}>
                    <SubTitle text={"After-Hours"} />
                    <div className={AHstyles.navIconsContainer}>
                      {(!hideEditforRedundantRequest)?<img src={PencilIcon} alt="edit icon" className={AHstyles.pageNavIcon} onClick={this.EditRequest} />:null}
                        <img src={DeleteIcon} alt="delete icon" className={AHstyles.pageNavIcon} onClick={this.DeleteRequest} />
                    </div>
                </div>

                <div className={styles.whiteContainer}>

                    <div className={AHstyles.blueStatusContainer}>
                        <p className={AHstyles.whiteStatusLabel}>{"Status"}</p>
                        <p className={AHstyles.whiteStatusText}>{this.state.requestStatus}</p>
                    </div>


                    <div className={AHstyles.fieldrow}>
                        <p className={AHstyles.documentformLabel}>{"Space"}</p>
                        <p className={AHstyles.documentformText}>{this.state.spaceName}</p>
                    </div>

                    <div className={AHstyles.fieldrow}>
                        <p className={AHstyles.documentformLabel}>{"From"}</p>
                        <p className={AHstyles.documentformText}>{this.state.fromDate} </p>
                    </div>

                    <div className={AHstyles.fieldrow}>
                        <p className={AHstyles.documentformLabel}>{"To"}</p>
                        <p className={AHstyles.documentformText}>{this.state.toDate} </p>
                    </div>

                    <div className={AHstyles.fieldrow}>
                        <p className={AHstyles.documentformLabel}>{"Comments"}</p>
                        <p className={AHstyles.documentformText}>{this.state.comment}</p>
                    </div>


                    <div className={AHstyles.fieldrow}>
                        <p className={AHstyles.fieldlabelvalue} >{"Estimated Cost"}</p> <p className={AHstyles.viewdetailsLink} onClick={this.toggle}>View Details</p>
                        <p className={AHstyles.documentformText} >{this.state.estimatedValue}</p>
                    </div>

                    <div className={AHstyles.fieldrow}>
                        <p className={AHstyles.documentformLabel}>{"Requested By"}</p>
                        <p className={AHstyles.documentformText}>{this.state.requestedBy}</p>
                    </div>

                </div>

                <Modal isOpen={this.state.modal} className={AHstyles.calculateCostModal} contentClassName={AHstyles.calculateModalContent}  >
                    <EstimatedCostDetailsModal onCloseModal={this.toggle} costDetails={this.props.Tenant_Request_Cost} />
                </Modal>
            </div>
        );
    }

    customiseData(data) {
        if (data !== null || data !== undefined) {
            this.setState({
                requestStatus: this.verifyRequestStatusType(data.status),
                spaceName: data.zoneName,
                zoneId: data.zoneId,
                fromDate: this.convertUTCString(data.startDateTime),
                toDate: this.convertUTCString(data.stopDateTime),
                comment: data.requestComment,
                requestedBy: data.userName,
            });
        }
    }

    //Converting UTC date to following format Fri, Dec 20 2019, 05:33 PM.
    convertUTCString(keyDate) {
        let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        let mon = ["Jan", "Feb", "Mar", "April", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let day = days[moment(keyDate).utcOffset(keyDate).day()];
        let date = moment(keyDate).utcOffset(keyDate).date();
        let month = mon[moment(keyDate).utcOffset(keyDate).month()];
        let year = moment(keyDate).utcOffset(keyDate).year();
        let time = moment(keyDate).utcOffset(keyDate).format('hh:mm A');
        return day + ", " + month + " " + date + " " + year + ", " + time;
    }

    verifyRequestStatusType(statusValue) {
        if (statusValue === 0) {
            this.setState({hideEditforRedundantRequest:false});
            return "Future Request";
        }
        else if (statusValue === 1) {
            this.setState({hideEditforRedundantRequest:false});
            return "Active Request";
        }
        else if (statusValue === 4) {
            this.setState({hideEditforRedundantRequest:true});
            return "Redundant Request";
        }
        else {
            return "Verify Request";
        }
    }

    //Calling the API for estimated cost details
    getEstimatedCost(data) {
        if (data !== null || data !== undefined) {
            let Request = null;
            Request = {
                "StartDateTime": data.startDateTime,
                "EndDateTime": data.stopDateTime,
                "IsRepeat": false,
                "TenantId": data.tenantId,
                "ZoneId": data.zoneId,
                "Comment": data.requestComment,
                "TenantUserId": data.userId,
            }
            this.props.GetCalculateCost(Request);
        }
    }

    //Delete request 
    //ToDo : Do we need confirmation popup?
    DeleteRequest() {
        let requestID = this.props.location.pathname.split('=')[1];
        if (requestID !== undefined) {
            var Data = [];
            Data.push({ requestId: String(requestID) });
            this.props.DeleteTenantRequests(Data);
            this.setState({ redirectToRequestsList: true });
        }
    }

    EditRequest(){
        let requestID = this.props.location.pathname.split('=')[1];
        if (requestID !== undefined) {
            this.setState({ navigateToEditRequest: true, editID:requestID });
        }
    }

}


const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getWorkorderPreferences: state.WorkorderRootReducer.WorkOrderStandardFields,
        Tenant_Request_Cost: state.tenantsRootReducer.Cost,
        requestdetailsfromReducer: state.RequestRootReducer.SelectedRequest
    };
};

const mapDispatchToProps = dispatch => {
    
    return {
        GetCalculateCost: (data) => dispatch(GetCalculateCost(data)),
        GetSelectedRequest: (RequestId) => dispatch(GetSelectedRequest(RequestId)),
        DeleteTenantRequests: (data) => dispatch(DeleteTenantRequests(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewAfterHoursRequest);


// Status 0 -> --request
// Status 1 -> Active request
// Status 2 -> --request
// Status 3 -> --request
// Status 4 -> --request